<template>
  <div>
    <div class="card">
      <div class="card-header animated fadeInRightBig">
        <div class="card-title">Solicitações de vale-transporte pendentes</div>
      </div>
      <div class="card-body">
        <div class="row mb-3">
          <div class="col-md-3">
            <input
              type="text"
              class="form-control"
              v-model="filters.name"
              placeholder="Filtrar por nome"
            />
          </div>
          <div class="col-md-2">
            <select class="form-control" v-model="filters.department_id">
              <option value="">Todos Departamentos</option>
              <option
                v-for="department in departments"
                :key="department.id"
                :value="department.id"
              >
                {{ department.title }}
              </option>
            </select>
          </div>
          <div class="col-md-2">
            <select class="form-control" v-model="filters.role_id">
              <option value="">Todos Cargos</option>
              <option v-for="role in roles" :key="role.id" :value="role.id">
                {{ role.title }}
              </option>
            </select>
          </div>
          <div class="col-md-2">
            <select class="form-control" v-model="filters.alocation_id">
              <option value="">Todas Alocações</option>
              <option
                v-for="alocation in alocations"
                :key="alocation.id"
                :value="alocation.id"
              >
                {{ alocation.name }}
              </option>
            </select>
          </div>
          <div class="col-md-2">
            <input type="date" class="form-control" v-model="filters.date" />
          </div>
        </div>
      </div>
      <div class="card-body">
        <div v-if="transportationRequests.length" class="row">
          <div
            v-for="transportationRequest in transportationRequests"
            :key="transportationRequest.id"
            class="col-md-6 offset-md-3 check-transportation-request-card"
          >
            <div class="row mb-3">
              <div class="col-md-9">
                <h6>
                  <b>Colaborador: </b>
                  {{ transportationRequest.user.name }}
                </h6>
                <h6>
                  <b>Data e hora: </b>
                  {{ format(transportationRequest.date) }}
                </h6>
                <div v-if="reprovingIds.includes(transportationRequest.id)" />
              </div>
              <div class="col-md-3">
                <div v-show="!reprovingIds.includes(transportationRequest.id)">
                  <button
                    class="btn btn-yes btn-block"
                    :disabled="disabled"
                    @click="approve(2, transportationRequest)"
                  >
                    Aprovar
                  </button>
                  <button
                    class="btn btn-no btn-block"
                    :disabled="disabled"
                    @click="justify(transportationRequest)"
                  >
                    Reprovar
                  </button>
                </div>
                <div v-show="reprovingIds.includes(transportationRequest.id)">
                  <button
                    class="btn btn-yes btn-block"
                    :disabled="disabled"
                    @click="approve(3, transportationRequest)"
                  >
                    Enviar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="!transportationRequests.length" class="row">
          <div class="col-md-6 offset-md-3">
            <div class="alert alert-primary" role="alert">
              Nenhuma solicitação pendente!
            </div>
          </div>
        </div>
      </div>
      <div class="block text-right mb-1">
        <router-link to="/transport_solicitations" class="btn btn-back mr-2">
          <i class="fa fa-arrow-left"></i> Voltar
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      transportationRequests: [],
      reprovingIds: [],
      departments: [],
      roles: [],
      alocations: [],
      filtredElements: [],
      disabled: false,
      loading: false,
      elementsReady: false,
      previewVisible: false,
      approveMultipleModalVisible: false,
      rejectMultipleModalVisible: false,
      bulkApproverJustification: "",
      previewUrl: "",
      previewImageError: false,
      previewImageLoaded: false,
      filters: {
        name: "",
        department_id: "",
        date: "",
        role_id: "",
        alocation_id: "",
      },
      filterTimer: null,
      pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 10,
        total: 0,
      },
    };
  },

  computed: {
    allVisibleSelected() {
      const visibleIds = this.filtredElements
        .filter(
          (transportationRequest) =>
            !this.reprovingIds.includes(transportationRequest.id),
        )
        .map((transportationRequest) => Number(transportationRequest.id));

      const selectedIds = this.selectedTr.map((id) => Number(id));

      return (
        visibleIds.length > 0 &&
        visibleIds.every((id) => selectedIds.includes(id))
      );
    },
  },

  methods: {
    justify(transportationRequest) {
      const self = this;
      const index = self.reprovingIds.findIndex(
        (x) => x == transportationRequest.id,
      );
      if (index !== -1) {
        self.reprovingIds.splice(index, 1);
      } else {
        self.reprovingIds.push(transportationRequest.id);
      }
    },
    approve(status_id, transportationRequest) {
      const self = this;
      self.disabled = true;
      const api = `${self.$store.state.api}transport_solicitations/approve/`;
      axios
        .post(api, {
          status_id,
          id: transportationRequest.id,
        })
        .then((response) => {
          self.getData();
          self.$message("Sucesso", "Dados registrados com sucesso", "success");
        })
        .catch((error) => {
          self.$message("Erro", error.response.data, "error");
        });
    },
    format(date) {
      return moment(date).format("DD/MM/YYYY");
    },
    getData() {
      const self = this;
      const api =
        self.$store.state.api +
        "transport_solicitations?status_id=1&with[]=user&paginated=false";
      const params = {
        status_id: 1,
        "with[]": ["user"],
        pagineted: false,
      };

      if (self.filters.name) params.name = self.filters.name;
      if (self.filters.department_id)
        params.department_id = self.filters.department_id;
      if (self.filters.role_id) params.role_id = self.filters.role_id;
      if (self.filters.alocation_id)
        params.alocation_id = self.filters.alocation_id;
      if (self.filters.date) params.date = self.filters.date;

      axios
        .get(api)
        .then((response) => {
          self.transportationRequests = response.data.data;
          self.disabled = false;
        })
        .catch((error) => {
          self.message("Erro", error.response.data, "error");
        });
    },
    getDepartments() {
      const self = this;
      const api = `${self.$store.state.api}departments`;
      axios
        .get(api)
        .then((response) => {
          console.log("departamentos");
          console.log(response);
          self.departments = response.data.data;
        })
        .catch((error) => {
          self.message("Erro", error.response.data, "error");
        });
    },
  },
};
</script>

<style scoped>
.check-transportation-request-card {
  border-radius: 10px;
  border: 1px solid black;
  margin-bottom: 5px;
  background-color: white;
  padding-top: 10px;
}

.btn-yes {
  border: 1px solid #2ea2cd;
  background-color: white;
  color: #2ea2cd;
}
.btn-yes:hover {
  border-radius: 1px solid white;
  background-color: #2ea2cd;
  color: white;
}

.btn-no {
  border: 1px solid rgb(255, 70, 70);
  background-color: white;
  color: rgb(255, 70, 70);
}
.btn-no:hover {
  border-radius: 1px solid white;
  background-color: rgb(255, 70, 70);
  color: white;
}

.dark-layout .check-transportation-request-card {
  background-color: #283046;
  border-color: #3b4253;
  color: #b4b7bd;
}

.check-request-card .dark_layout {
  border-radius: 10px;
  border: 1px solid black;
  margin-bottom: 5px;
  background: #1e293b;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.12);
}
</style>
